import { HTMLProps, ReactNode } from "react";
import cn from "classnames";
import styles from "./Layout.module.scss";

type ContainerProps = {
  children: ReactNode;
  addGap?: boolean;
} & HTMLProps<HTMLDivElement>;

export default function Container({
  children,
  addGap = false,
  className,
  ...rest
}: ContainerProps) {
  return (
    <div
      className={cn(styles.container, addGap && styles.containerGap, className)}
      {...rest}
    >
      {children}
    </div>
  );
}
